<template>
  <ModalDialog
    ref="dialog"
    title="Edit User"
    icon="fa-user"
    :submitting="submitting"
    submitTitle="Update"
    :scrollable="true"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="userForm" :labelColumnSize="2">
      <FormRow label="Email"><FormInputText v-model="user.email" field="email" type="email" /></FormRow>
      <FormHorizontalRule />
      <FormRow label="Title"><FormSelect v-model="user.title" field="title" :options="titleOptions" /></FormRow>
      <FormRow label="Name"><FormInputText v-model="user.name" field="name" placeholder="Name" /></FormRow>
      <FormRow label="Phone"><FormInputText v-model="user.phone" field="phone" placeholder="Phone Number" /></FormRow>
      <FormRow label="Mobile"><FormInputText v-model="user.mobile" field="mobile" placeholder="Mobile Number" /></FormRow>
      <FormRow label="Reply To Email" helpTip="If set, uses this reply to address in outgoing emails sent by this user. Otherwise, defaults to account reply to field">
        <FormInputText v-model="user.emailReplyToAddress" field="emailReplyToAddress" type="email" placeholder="Reply To" />
      </FormRow>
      <FormRow label="Date Of Birth"><FormDate v-model="user.dateOfBirth" field="dateOfBirth" placeholder="Date of Birth" /></FormRow>
      <FormHorizontalRule />
      <FormRow label="Timezone Code">
        <FormSearchableSelect :options="timezoneCodeList" placeholder="Timezone" v-model="user.timezoneCode" field="timezoneCode" />
      </FormRow>
      <FormRow label="Labels"><FormLabelTag popupName="User Labels" v-model="user.labelList" labelType="user" field="labelList" /></FormRow>
      <FormRow label="Highlight Colour" helpTip="Highlight colour for the user used in the calendar and maps for task management">
        <FormColourTag v-model="user.highlightColour" field="highlightColour" />
      </FormRow>

      <FormRow label="User Groups"><FormMultiSelect :value="userGroupMembership" @input="userGroupMembership = $event" :options="userGroupList" :loading="userGroupListLoading" placeholder="Select User Groups" /></FormRow>
      <FormHorizontalRule />
      <FormRow label="Available As Task Resource" helpTip="If set, the user is available to be assigned to tasks">
        <FormCheckbox v-model="user.isTaskResource" field="isTaskResource" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import moment from 'moment-timezone'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import { PersonTitleLookup } from '@/store/types'

export default {
  name: "UserEditDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    userId: Number
  },
  data() {
    return {
      user: {
        labelList: [],
        highlightColour: null
      },
      userForm: {},
      submitting: false,
      titleOptions: PersonTitleLookup,
      userGroupMembership: [],
      userGroupList: [],
      userGroupListLoading: false,
      timezoneCodeList: []
    }
  },
  mounted() {
    this.timezoneCodeList = moment.tz.names().map(tz => { return { name: tz, value: tz } })
  },
  computed: {
  },
  methods: {
    show(user) {
      // Reset form
      this.user = {
        labelList: [],
        highlightColour: null
      }
      this.userGroupMembership = []
      this.userForm = {}
      this.submitting = false
      this.userGroupList = []

      if(user != null) {
        this.user = _.cloneDeep(user)

        if(this.user.userGroups != null)
          this.userGroupMembership = this.user.userGroups.map(userGroup => { return userGroup.id })
      }

      // Autodetect the timezone
      if(this.user.timezoneCode == null || this.user.timezoneCode == '')
        this.user.timezoneCode = moment.tz.guess()
      
      // Get User Group list
      // FUTURE: Somehow send a promise to the select component. It can handle loading state based on promise
      this.userGroupListLoading = true
      this.$apiService.userService.getUserGroupList()
      .then(list => {
        this.userGroupList = list.data.map(userGroupInfo => {
          return {
            value: userGroupInfo.id,
            name: userGroupInfo.name,
            colour: userGroupInfo.colourTag
          }
        })
        this.userGroupListLoading = false
      })

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var userData = _.cloneDeep(this.$data.user)
      userData.userGroups = this.userGroupMembership
      
      // Only update certain fields
      // Don't update password
      var updateData = _.pick(userData, ['email', 'title', 'name', 'phone', 'mobile', 'dateOfBirth', 'emailReplyToAddress', 'userGroups', 'timezoneCode', 'highlightColour', 'isTaskResource', 'labelList'])
      updateData.labelList = updateData.labelList.map(label => label.id)

      this.$apiService.userService.updateUser(this.userId, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.userForm = this.processFormResponse(err)
        })
    },
  }
}
</script>